import { useEffect, useMemo, useState } from 'react';
export const useOnOverflow = ({ ellipsis, ref, ellipsedCallback, }) => {
    const [scrollWidth, setScrollWidth] = useState(0);
    const [offsetWidth, setOffsetWidth] = useState(0);
    useEffect(() => {
        if (!ellipsis)
            return;
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target) {
                    setScrollWidth(entry.target.scrollWidth);
                    // @ts-ignore
                    setOffsetWidth(entry.target.offsetWidth);
                }
            }
        });
        if (ref.current)
            resizeObserver.observe(ref.current);
        return () => {
            if (ref.current)
                resizeObserver.unobserve(ref.current);
        };
    }, [ellipsis, ref]);
    const isEllipsed = useMemo(() => {
        return ellipsis && scrollWidth > offsetWidth;
    }, [scrollWidth, offsetWidth, ellipsis]);
    useEffect(() => {
        if (isEllipsed != null)
            ellipsedCallback?.(isEllipsed);
    }, [isEllipsed, ellipsedCallback]);
    return isEllipsed;
};
